const COMPONENT_SELECTOR = 'lib-babylon-lis-c2-img-vid';
const FILTER_CLASS = 'babylon_lisc2imgvid__filter';
const SELECTED_CLASS = 'selected';
const LIB_FILTER_SELECTED_CLASS = 'babylon_lisc2imgvid__filter--selected';

function getFilterElement(target: EventTarget | null): HTMLElement | null {
    if (!(target instanceof HTMLElement)) {
        return null;
    }
    return target.closest(`.${FILTER_CLASS}`);
}

function getComponentRoot(filterElement: HTMLElement): HTMLElement | null {
    return filterElement.closest(COMPONENT_SELECTOR);
}

function updateSelectedFilter(filterElement: HTMLElement): void {
    const root = getComponentRoot(filterElement);
    if (!root) {
        return;
    }

    const filters = Array.from(
        root.querySelectorAll<HTMLElement>(`.${FILTER_CLASS}`)
    );

    filters.forEach((item) => {
        item.classList.remove(SELECTED_CLASS);
        item.classList.remove(LIB_FILTER_SELECTED_CLASS);
    });

    filterElement.classList.add(SELECTED_CLASS);
    filterElement.classList.add(LIB_FILTER_SELECTED_CLASS);
}

export function initializeBabylonFilterSelection(): void {
    if (typeof document === 'undefined') {
        return;
    }

    document.addEventListener('click', (event) => {
        const clickedFilter = getFilterElement(event.target);
        if (!clickedFilter) {
            return;
        }

        const root = getComponentRoot(clickedFilter);
        if (!root) {
            return;
        }

        updateSelectedFilter(clickedFilter);
    });
}

initializeBabylonFilterSelection();
